import deepmerge from "deepmerge";

export function getNumberOfFiltersApplied(filters) {
  const isBlank = (value) => !value;
  const isPresent = (value) => !!value;

  let count = 0;

  Object.entries(filters).forEach(([key, value]) => {
    if (isBlank(value)) {
      return;
    }
    // Count each custom work order field filter separately
    if (key === "customWorkOrderFieldFilters" && Array.isArray(value)) {
      count += value.length;
      return;
    }
    if (Array.isArray(value)) {
      if (value.length > 0) count += 1;
      return;
    }
    if (typeof value === "object") {
      if (isPresent(value.startsAt) || isPresent(value.endsAt)) count += 1;
      return;
    }
    count += 1;
  });

  return count;
}

export function mergeState(object1, object2) {
  return deepmerge(object1, object2, {
    arrayMerge: (_oldArray, newArray) => newArray,
  });
}
